"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiEpisode = /** @class */ (function (_super) {
    __extends(ApiEpisode, _super);
    function ApiEpisode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_EPISODE_NEW_ID = "/api/episode/getNewId";
        _this.GET_EPISODE_LIST = "/api/episode/all";
        _this.GET_EPISODE = "/api/episode";
        _this.GET_EPISODE_LAST_INFO = "/api/episode/get/lastEpisodeInformation";
        _this.GET_EPISODE_COIN_RESERVATION_ID = "/api/episode/coinReservation/create";
        _this.GET_EPISODE_COIN_RESERVATION_META = "/api/episode/coinReservation/getMeta";
        _this.GET_EPISODE_COIN_RESERVATION = "/api/episode/coinReservation/get";
        _this.GET_EPISODE_COIN_RESERVATION_LIST = "/api/episode/coinReservation/list";
        _this.UPDATE_EPISODE = "/api/episode/update";
        _this.UPDATE_EPISODE_SORT = "/api/episode/sort";
        _this.UPDATE_EPISODE_CONTENT_SORT = "/api/image/episode/contents/sort";
        _this.UPDATE_EPISODE_COIN_RESERVATION = "/api/episode/coinReservation/set";
        _this.DELETE_EPISODE = "/api/episode/delete";
        _this.DELETE_EPISODE_COIN_RESERVATION = "/api/episode/coinReservation/delete";
        _this.DELETE_EPISODE_CONTENTS_ALL = "/api/image/episode/contents/delete/all";
        /**
         * 신규 comic id 발급 api
         * @param accesstoken
         * @returns
         */
        _this.getEpisodeNewId = function (accesstoken, comicId) {
            var data = {
                comicId: comicId,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_EPISODE_NEW_ID,
                data: data,
            });
        };
        /**
         * 만화 회차리스트 api
         * @param accesstoken
         * @param comicId
         * @param language
         */
        _this.getEpisodeList = function (accesstoken, comicId, language) {
            var data = {
                language: language,
            };
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.GET_EPISODE_LIST, "/").concat(comicId),
                data: data,
            });
            return req;
        };
        /**
         * 회차 상세 정보
         * @param accesstoken
         * @param language
         * @param episodeId
         * @returns
         */
        _this.getEpisode = function (accesstoken, language, episodeId) {
            var data = {
                language: language,
            };
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.GET_EPISODE, "/").concat(episodeId),
                data: data,
            });
            return req;
        };
        /**
         * 만화의 마지막 회차 정보
         * @param accesstoken
         * @param language
         * @param comicId
         * @returns
         */
        _this.getEpisodeLastInfo = function (accesstoken, language, comicId) {
            var data = {
                comicId: comicId,
                language: language,
            };
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_EPISODE_LAST_INFO,
                data: data,
            });
            return req;
        };
        /**
         * 코인 일괄 수정 stack 추가
         * @param accesstoken
         * @param comicId
         * @param language
         * @returns
         */
        _this.getEpisodeCoinReservationNewId = function (accesstoken, comicId, language) {
            var data = {
                comicId: comicId,
                language: language,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_EPISODE_COIN_RESERVATION_ID,
                data: data,
            });
        };
        /**
         * @deprecated coinReservation/get와 중복 되므로 추후 제거 예정
         * 코인 일괄설정 data (생성시만 사용)
         * @param accesstoken
         * @param coinReservationId
         * @returns
         */
        _this.getEpisodeCoinReservationNewMeta = function (accesstoken, coinReservationId) {
            var data = {
                coinReservationId: coinReservationId,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_EPISODE_COIN_RESERVATION_META,
                data: data,
            });
        };
        /**
         * 코인 일괄설정 data
         * @param accesstoken
         * @param coinReservationId
         * @returns
         */
        _this.getEpisodeCoinReservation = function (accesstoken, coinReservationId) {
            var data = {
                coinReservationId: coinReservationId,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_EPISODE_COIN_RESERVATION,
                data: data,
            });
        };
        /**
         * 코인 예약 내역
         * @param accesstoken
         * @param comicId
         * @param language
         * @returns
         */
        _this.getEpisodeCoinReservationList = function (accesstoken, comicId, language) {
            var data = {
                comicId: comicId,
                language: language,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_EPISODE_COIN_RESERVATION_LIST,
                data: data,
            });
        };
        /**
         * 회차 상세 정보 업데이트
         * @param accesstoken
         * @param comicId
         * @param request
         * @returns
         */
        _this.updateEpisode = function (accesstoken, comicId, request) {
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.UPDATE_EPISODE, "/").concat(comicId),
                data: request,
            });
            return req;
        };
        /**
         * 회차리스트 정렬
         * @param accesstoken
         * @param comicId
         * @param language
         * @param episodeIds
         * @returns
         */
        _this.updateEpisodeListSort = function (accesstoken, comicId, language, episodeIds) {
            var data = {
                comicId: comicId,
                language: language,
                episodeIds: episodeIds,
            };
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.UPDATE_EPISODE_SORT,
                data: data,
            });
            return req;
        };
        /**
         * 회차리스트 image content 정렬
         * @param accesstoken
         * @param episodeId
         * @param imageIds
         * @returns
         */
        _this.updateEpisodeContentSort = function (accesstoken, episodeId, imageIds) {
            var data = {
                episodeId: episodeId,
                imageIds: imageIds,
            };
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.UPDATE_EPISODE_CONTENT_SORT,
                data: data,
            });
            return req;
        };
        /**
         * 코인 일괄수정 업데이트
         * @param accesstoken
         * @param req
         * @returns
         */
        _this.updateEpisodeCoinReservation = function (accesstoken, req) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.UPDATE_EPISODE_COIN_RESERVATION,
                data: req,
            });
        };
        /**
         * 회차 삭제
         * @param accesstoken
         * @param episodeId
         * @param comicId
         * @returns
         */
        _this.deleteEpisode = function (accesstoken, episodeId, comicId) {
            var data = {
                comicId: comicId,
            };
            var req = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: "".concat(_this.DELETE_EPISODE, "/").concat(episodeId),
                data: data,
            });
            return req;
        };
        /**
         * 코인 내역 삭제
         * @param accesstoken
         * @param coinReservationId
         * @returns
         */
        _this.deleteEpisodeCoinReservation = function (accesstoken, coinReservationId) {
            var data = {
                coinReservationId: coinReservationId,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.DELETE_EPISODE_COIN_RESERVATION,
                data: data,
            });
        };
        /**
         * 회차리스트 컨텐츠 이미지 전체 삭제
         * @param accesstoken
         * @param episodeId
         * @returns
         */
        _this.deleteEpisodeContentsAll = function (accesstoken, episodeId, language) {
            var data = {
                episodeId: episodeId,
                language: language,
            };
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.DELETE_EPISODE_CONTENTS_ALL,
                data: data,
            });
        };
        return _this;
    }
    ApiEpisode.getInstance = function (initValue) {
        if (!ApiEpisode.classInstance) {
            this.classInstance = new ApiEpisode(initValue);
        }
        return this.classInstance;
    };
    return ApiEpisode;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiEpisode;
